/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as core from '../../core';
import * as errors from '../../errors/index';
import * as Truvity from '../index';

export class ForbiddenError extends errors.TruvityError {
    constructor(body: Truvity.ForbiddenProblems, rawResponse?: core.RawResponse) {
        super({
            message: 'ForbiddenError',
            statusCode: 403,
            body: body,
            rawResponse: rawResponse,
        });
        Object.setPrototypeOf(this, ForbiddenError.prototype);
    }
}
